import InitPopups from './js/popup.js';
import MobileMenu from './js/mobile-menu.js';
import LogosSlider from './js/logos.js';
import NumbersCounter from './js/numbers.js';
import PlanAccordion from './js/plan-accordion.js';
import TestimSlider from './js/testimonials.js';
import RevealAnimations from './js/reveal-animations.js';
import BlogPosts from './js/blog-posts.js';
import SinglePostToc from './js/single-post-toc.js';
import VideoSlider from './js/video-slider.js';
import ContactForm7Safeguard from './js/contact-form-7.js';
import HeroParallax from './js/hero-parallax.js';
import RevealParallax from './js/reveal-parallax.js';
import ButtonParallax from './js/button-parallax.js';

import './js/header-submenu';
import './scss/main.scss';

/*
 * On DOM Content Load
 */
document.addEventListener('DOMContentLoaded', () => {

  InitPopups();
  MobileMenu();
  LogosSlider();
  NumbersCounter();
  PlanAccordion();
  TestimSlider();
  RevealAnimations();
  BlogPosts();
  SinglePostToc();
  VideoSlider();
  ContactForm7Safeguard();
  HeroParallax();
  RevealParallax();
  ButtonParallax();

});

/*
 * On Full Page Load
 */
window.addEventListener('load', () => {

});
